import React from 'react';
import Layout from '../../shared/components/Layout';
import Complete from '@/components/Complete';

const CustomerComplete: React.FC = () => {
  return (
    <React.Fragment>
      <Layout>
        <Complete id="page-facility_login" heading="お客様情報変更申込完了" content="お客様情報変更申込が完了しました。"  />
      </Layout>
    </React.Fragment>
  )
}

export default CustomerComplete;